import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { generateName } from '../Utils/rules'
import { generateFormData } from '../Utils/helpers'
import { ERROR_CODE } from '../Utils/constants'
import {
  getUtcUnixDate,
  getCurrentTimeMoment,
  getStartDate,
} from '../Utils/rules'

export default class BudgetStore extends FetchBase {
  @observable ordering = undefined
  @observable orderingBy = undefined

  @observable LineItemSearchText = ''
  @observable lineItemsFilters = {}
  @observable LineItemList = []
  @observable totalListItem = 0
  @observable listItemPageNo = DEFAULT_PAGE_START
  @observable mediaCentricUsersLoader = true
  @observable selectedCustomerId = undefined
  @observable searchTextForUsersList = undefined
  @observable pfSelectedDateChoice = undefined
  @observable usersFilters = {}
  @observable isCheckAll = false
  @observable setCheckeFileList = []
  @observable superAdminInfo = []

  @observable ordering = undefined
  @observable orderBy = undefined

  @observable importUsers = []
  @observable importUsersFailures = []
  @observable importUserFromFileLoader = false

  @observable addActionItemLoader = false

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  SetListItemPageNo = (value = DEFAULT_PAGE_START) => {
    this.listItemPageNo = value
  }

  @action.bound
  setLineItemFilters = (values = {}) => {
    this.lineItemsFilters = values
  }

  @action.bound
  setLineItemSearchText = (value = '') => {
    this.LineItemSearchText = value
  }

  @action.bound
  setSearchTextForUsersList = (value = undefined) => {
    this.searchTextForUsersList = value
  }

  @action.bound
  setSelectedCustomerId = (id) => {
    this.selectedCustomerId = id
  }

  @action.bound
  setSelectedDateChoice = (value) => {
    this.pfSelectedDateChoice = value
  }

  @action.bound
  getFilters = () => {
    let temp = {}
    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }
    return temp
  }

  @action.bound
  getAllLineItemsExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.generateLineItemFilters()
      options['exportFileType'] = exportFileType
      let response = await this.get(API_ENDPOINTS.EXPORT_LINE_ITEM, {
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setDownloadFile = async (list = [], totalFiles, id) => {
    this.setCheckeFileList = list
    this.isCheckAll = list?.length === totalFiles
  }

  @action.bound
  generateLineItemFilters = () => {
    let temp = {}

    this.LineItemSearchText && (temp['search'] = this.LineItemSearchText)
    let keys = Object.keys(this.lineItemsFilters || {})
    for (let filter of keys) {
      if (this.lineItemsFilters[filter] !== undefined) {
        temp[filter] = this.lineItemsFilters[filter]
      }
    }

    if (temp['endDate']) {
      temp['endDateMax'] = getStartDate(temp['endDate'])
    }
    let { start, end } = getUtcUnixDate(this.pfSelectedDateChoice, {
      start: temp?.startDate,
      end: temp?.endDate,
    })

    start ? (temp['startDate'] = start) : delete temp['startDate']
    end ? (temp['endDate'] = end) : delete temp['endDate']
    temp['startDate'] && delete temp['endDateMax']

    delete temp['choice']
    delete temp['dateChoice']

    this.ordering && (temp['ordering'] = this.ordering)
    this.ordering && (temp['orderBy'] = this.orderingBy)

    return temp
  }

  @action.bound
  listLineItem = async (signal) => {
    try {
      this.mediaCentricUsersLoader = true
      let options = this.generateLineItemFilters() || {}
      let filters = this.getFilters()

      options['pageLimit'] = '0'

      this.searchTextForUsersList &&
        (options['search'] = this.searchTextForUsersList)
      let response = await this.get(
        API_ENDPOINTS.LIST_LINE_ITEM,
        options,
        signal
      )
      if (response.status) {
        this.LineItemList = response.data.budgetLineItems
        this.totalListItem = response.data.total
        return true
      }
      this.LineItemList = []

      return false
    } catch (err) {
      this.LineItemList = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  subPlanItem = async (signal) => {
    try {
      this.mediaCentricUsersLoader = true
      let options = this.generateLineItemFilters() || {}

      let response = await this.get(
        API_ENDPOINTS.SUB_PLAN_DETAILS,
        options,
        signal
      )
      if (response.status) {
        this.subPlanDetailsId = response.data.subPlanId
        this.totalListDetailItem = response.data.totalListItem
        return true
      }

      return false
    } catch (err) {
      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  checkIfLineItemExist = async (value) => {
    try {
      let respone = await this.post(API_ENDPOINTS.CHECK_LINE_ITEM_EXISTS, {
        name: value,
      })
      if (respone?.status) {
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch {
      return [false, undefined]
    }
  }

  @action.bound
  listLineItemforFilter = async () => {
    try {
      this.mediaCentricUsersLoader = true
      let options = this.generateLineItemFilters() || {}
      let filters = this.getFilters()

      filters['pageLimit'] = '0'
      this.searchTextForUsersList &&
        (options['search'] = this.searchTextForUsersList)
      let response = await this.get(API_ENDPOINTS.LIST_LINE_ITEM, {
        ...options,
        pageLimit: '0',
      })
      if (response.status) {
        this.LineItemList = response.data.budgetLineItems
        this.totalListItem = response.data.total
        return true
      }
      this.LineItemList = []

      return false
    } catch (err) {
      this.LineItemList = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  deleteLineItem = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_LINE_ITEM, {
        id: id,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteBulklineitem = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS?.BULK_DELETE_LINE_ITEM, {
        ids: id,
      })
      if (response.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  // Add Line Item
  @action.bound
  addLineItem = async (values) => {
    try {
      this.addActionItemLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_LINE_ITEM, values)
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addActionItemLoader = false
    }
  }

  @action.bound
  getLineItem = async (id) => {
    try {
      this.addActionItemLoader = true
      let response = await this.get(API_ENDPOINTS.GET_LINE_ITEM_BY_ID, {
        id,
      })
      if (response.status) {
        this.actionItem = response?.data
        return [true, response.data]
      }
      this.actionItem = {}
      return [false, undefined]
    } catch (err) {
      this.actionItem = {}
      return [false, undefined]
    } finally {
      this.actionItemLoader = false
    }
  }

  @action.bound
  getSuperAdmin = async (signal) => {
    try {
      this.addActionItemLoader = true
      const roleId = { roleId: [1] }

      let response = await this.get(
        API_ENDPOINTS.DROP_DOWN_NEW_MEDIACENTRIC_USER_LIST,
        roleId,
        signal
      )
      if (response.status) {
        this.superAdminInfo = response?.data[0].userMeta[0]
        return [true, response.data]
      }
      this.superAdminInfo = {}
      return [false, undefined]
    } catch (err) {
      this.superAdminInfo = {}
      return [false, undefined]
    } finally {
      this.actionItemLoader = false
    }
  }

  @action.bound
  updateLineItem = async (id, values) => {
    try {
      this.addActionItemLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_LINE_ITEM, {
        id,
        ...values,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addActionItemLoader = false
    }
  }

  @action.bound
  importConfigBudget = async (values) => {
    try {
      this.importUserFromFileLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.IMPORT_CONFIG_BUDGET_FROM_FILE,
        formDataValues
      )
      if (response.status) {
        this.importUsers = response.data || []
        this.importUsersFailures =
          {
            headerMessage: response?.message || '',
            failedErrors: response.data?.failures || [],
            fileUpload: response.status,
            isError: true,
          } || []
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      if (err?.error?.statusCode === ERROR_CODE?.MENUAL_CODE) {
        this.importUsersFailures =
          {
            headerMessage: err?.message,
            failedErrors: null,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      } else {
        this.importUsersFailures =
          {
            headerMessage: err?.message,
            failedErrors: err?.error,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      }
    } finally {
      this.importUserFromFileLoader = false
    }
  }

  @action.bound
  importUsersFromFileReset = async () => {
    this.importUsers = []
    this.importUsersFailures = []
  }

  @action.bound
  resetFilterForm = () => {
    this.lineItemsFilters = {}
    this.pfSelectedDateChoice = undefined
  }

  @action.bound
  resetUserFilters = () => {
    this.usersFilters = {}

    this.ordering = undefined
    this.orderBy = undefined
  }

  @action.bound
  resetStore = () => {
    this.ordering = undefined
    this.orderingBy = undefined

    this.LineItemSearchText = ''
    this.lineItemsFilters = {}
    this.LineItemList = []
    this.totalListItem = 0
    this.listItemPageNo = DEFAULT_PAGE_START
    this.mediaCentricUsersLoader = true
    this.selectedCustomerId = undefined
    this.searchTextForUsersList = undefined
    this.usersFilters = {}
    this.superAdminInfo = []
    this.ordering = undefined
    this.orderBy = undefined
    this.addActionItemLoader = false
    this.pfSelectedDateChoice = undefined
    this.isCheckAll = false
    this.setCheckeFileList = []

    this.importUsers = []
    this.importUsersFailures = []
    this.importUserFromFileLoader = false
  }
}
